



















import { defineComponent, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  setup(_, ctx) {
    const trimImgExt = (path: string) => path.replace(/\.(webp|jpg)$/, '')

    const height = computed(() => {
      if (ctx.root.$vuetify.breakpoint.xsOnly) {
        return 300
      }

      if (ctx.root.$vuetify.breakpoint.mdAndDown) {
        return 400
      }

      return 500
    })

    return { height, trimImgExt }
  },
})
